import { render, staticRenderFns } from "./iPhoneX.vue?vue&type=template&id=1fca3c2b"
import script from "./iPhoneX.vue?vue&type=script&lang=js"
export * from "./iPhoneX.vue?vue&type=script&lang=js"
import style0 from "./iPhoneX.vue?vue&type=style&index=0&id=1fca3c2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports